<template>
  <router-view />
</template>

<script>

export default {
  name: "App",
  components: {
  },
};
</script>

<style>
/* Color Variables */
:root {
  --dark-bg: #0c0c0c;
  --darker-bg: #080808;
  --card-bg: #1a1a1a;
  --gold-primary: #d4af37;
  --gold-secondary: #b8941f;
  --gold-light: #f4e4a9;
  --gold-dark: #8b6914;
  --text-gold: #ffd700;
  --text-light: #f8f9fa;
  --text-muted: #a0a0a0;
  --border-gold: rgba(212, 175, 55, 0.3);
  --shadow-gold: rgba(212, 175, 55, 0.4);
  --success-color: #28a745;
  --error-color: #dc3545;
  --urgent-red: #e74c3c;
  --high-orange: #f39c12;
  --normal-blue: #3498db;
  --low-green: #2ecc71;
}

body {
  background-color: black;
  color: rgb(0, 0, 0);
  /* Optional: to make text visible on a black background */
}

body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.7) 1px, transparent 1px);
  background-size: 20px 20px;
  /* Adjust for star size */
  opacity: 0.2;
  /* Adjust for star brightness */
  pointer-events: none;
  /* Allow clicks through to the content */
}

body::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.7) 1px, transparent 1px);
  background-size: 20px 20px;
  /* Adjust for star size */
  opacity: 0.2;
  /* Adjust for star brightness */
  pointer-events: none;
  /* Allow clicks through to the content */
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--gold-secondary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--gold-light);
  border-radius: 4px;
  border: 2px solid var(--gold-secondary);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--gold-light);
}
</style>
